import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from '../../components/default/header';
import GlobalSidebarMenu from '../default/header/globalSidebarMenu';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "../default/breadcrumb/breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { markAllNotificationsAsRead, notificationAction, notificationStatusUpdateAction} from "../../store/actions/new/notificationAction";
import { ShimmerCategoryItem } from "react-shimmer-effects";
import NoContentFound from "../default/not-found/notFound";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { PrismTimeFormatter } from "../default/utils/timeFormatter";
import DataModelPopup from "../default/popup/dataModel/contentModelPopup";
import SingleNotificationData from "./single/singleNotificationData";

const Notification = () => {
    const [filter, setFilter] = useState("");
    const [pageCount, setPageCount] = useState(1);
    const [markAllAlert, setMarkAllAlert] = useState(false);
    const [openDataPopup, setDataPopup] = useState(false);
    const [notificationId, setNotificationId] = useState('');
    const [notificationStatus, setNtfStatus] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { notificationAllData, unreadData, archiveData, isLoading } = useSelector((store) => store.notificationData);
    // total unread data
    const totalUnread = notificationAllData.unread ? notificationAllData.unread :"";
    useEffect(() => {

        if (location.pathname.includes("unread")) {
            // Check if store already has data
            setFilter("new")
            if (!unreadData || !unreadData.data || unreadData.data.length === 0) {
                dispatch(notificationAction(1,"new"));
            }
        }else if(location.pathname.includes("archived")){

            // Check if store already has data
            setFilter("archive")
            if (!archiveData || !archiveData.data || archiveData.data.length === 0) {
                dispatch(notificationAction(1,"archive"));
            }
        }else {
            // Check if store already has data
            setFilter("")
            if (!notificationAllData || !notificationAllData.data || notificationAllData.data.length === 0) {
                dispatch(notificationAction(1,""));
            }
        }
    }, [dispatch, location.pathname]);

    let data, pagination;
    if (location.pathname.includes("unread")) {
        data = unreadData.data;
        pagination = unreadData.pagination;
    } else if (location.pathname.includes("archive")) {
        data = archiveData.data;
        pagination = archiveData.pagination;
    } else {
        data = notificationAllData.data;
        pagination = notificationAllData.pagination;
    }
    const loadMore = () => {
        const nextPage = pagination.page + 1;
        if (nextPage <= pagination.page_last) {
            setPageCount(nextPage);
            dispatch(notificationAction(nextPage, filter));
        }
    };

    const MySwal = withReactContent(Swal)
    // Mark all as read
    const markAllAsRead = () => {
        MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Conform"
          }).then((result) => {
            if (result.isConfirmed) {
                dispatch(markAllNotificationsAsRead());
                navigate('/notification');
            }
          });
        
       
    };

    // Handle single notification click
    const handleNotificationClick = (id, status) => {
        // Dispatch an action to mark single notification as read
        if(status === "new"){
            dispatch(notificationStatusUpdateAction(id));
        }
        navigate(`/notification/${id}?status=${status}`);
    };

    const handleCloseModal = () => {
        setDataPopup(false);
    };
     // data model popup
     const handleDataPopup = (event, dataId, status) => {
        event.preventDefault();
        setDataPopup(false);
        setNotificationId(null);
        setNtfStatus(null);
        setTimeout(() => {
            setNotificationId(dataId);
            setNtfStatus(status);
            setDataPopup(true);
        }, 100);
    }

    return (
        <div className="content-wrapper sidebar-menu-enable">
            <Helmet><title>Notifications - Cardiast</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <GlobalSidebarMenu sidebarTitle="" />
                <div className="content-right">
                    <Breadcrumb />
                    <div className="connection-header">
                        <h3>Notifications</h3>
                    </div>
                    <div className="notification-wrapper">
                        <div className="notification-header">
                            <ul>
                                <li>
                                    <Link className={`${location.pathname.endsWith("notification") ? "active-filter" : ""}`} onClick={()=> setFilter("")} to="/notification">All</Link>
                                </li>
                                <li>
                                    <Link className={`${location.pathname.endsWith("unread") ? "active-filter" : ""}`} onClick={()=> setFilter("unread")} to="/notification/unread">Unread</Link>
                                </li>
                                <li>
                                    <Link className={`${location.pathname.endsWith("archived") ? "active-filter" : ""}`} onClick={()=> setFilter("archive")} to="/notification/archived">Archived</Link>
                                </li>
                            </ul>
                            {totalUnread > 0 ? 
                                <ul>
                                    <li>
                                        <Link to="#" onClick={markAllAsRead}>Mark all as read</Link>
                                    </li>
                                </ul>
                            : ""}
                            
                        </div>
                        <div className="notification-list">
                            <div className="more-pck-wrapper">
                                { data && data.length > 0 ? (
                                    data.map((notification) => (
                                        <div
                                            key={notification.id}
                                            className={`mr-single-package ${notification.status === "new" ? "active" : ""}`}
                                            onClick={(e) => handleDataPopup(e, notification.id, notification.status)}
                                        >
                                            <div className="mrp-details">
                                                <img src={notification.icon} alt="card profile" />
                                                <div className="ntf-prf-content">
                                                    <h4>{notification.title}</h4>
                                                    <span>{notification.content}</span>
                                                </div>
                                            </div>
                                            <div className="nft-time">
                                                {PrismTimeFormatter(notification.date)}
                                            </div>
                                        </div>
                                    ))
                                ): ""}
                                {!isLoading && pagination && pagination.data_total === 0 &&
                                     <NoContentFound title="No notification found!"/>
                                }
                                {/* Notifiaction data popup */}
                                <DataModelPopup openModal={openDataPopup} setOpen={setDataPopup} sourceUrl={`/notification/${notificationId}?status=${notificationStatus}`} bodyData={<SingleNotificationData popupItemId={notificationId} onClose={handleCloseModal} ntfStatus={notificationStatus} />} />
                                {isLoading && 
                                    <>
                                            <ShimmerCategoryItem
                                            hasImage
                                            imageType="circular"
                                            imageWidth={50}
                                            imageHeight={50}
                                            text
                                        />
                                        <ShimmerCategoryItem
                                            hasImage
                                            imageType="circular"
                                            imageWidth={50}
                                            imageHeight={50}
                                            text
                                        />
                                    </>
                                }
                                {!isLoading && pagination  && pagination.page_last > pagination.page && (
                                    <div className="load-more-container">
                                        <button 
                                            className="load-more-btn" 
                                            onClick={loadMore}
                                            disabled={isLoading}
                                        >
                                            {isLoading ? 'Loading...' : 'Load More'}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Notification;
